import { render } from "./BatchFirstUseBlankslate.vue?vue&type=template&id=4998ec45"
import script from "./BatchFirstUseBlankslate.vue?vue&type=script&lang=js"
export * from "./BatchFirstUseBlankslate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__